import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

export default function FundingPrograms() {
  const [products, setProducts] = useState([]);
  useEffect(() => { api.get("/products").then((r) => setProducts(r.data)); }, []);
  return (
    <div className="max-w-[1360px] space-y-14" data-testid="programs-page">
      <header>
        <div className="small-caps text-slate-500">Programs</div>
        <h1 className="mt-6 font-semibold text-[72px] leading-[0.9] tracking-tight text-[#1F2937]">
          The <span className="italic">mandates.</span>
        </h1>
      </header>

      <div>
        <div className="grid grid-cols-12 py-3 border-b border-slate-200 small-caps text-slate-500">
          <div className="col-span-1">No.</div>
          <div className="col-span-6">Loan Program</div>
          <div className="col-span-3">Range</div>
          <div className="col-span-2 text-right">Close</div>
        </div>
        {products.map((p, i) => (
          <div key={p.id} className="grid grid-cols-12 items-baseline py-6 border-b border-slate-200 row-hover">
            <div className="col-span-1 font-mono text-[11px] text-slate-400 pt-1">{String(i + 1).padStart(2, "0")}</div>
            <div className="col-span-6">
              <div className="font-semibold text-[24px] text-[#1F2937]">{p.name}</div>
              <div className="small-caps text-slate-400 mt-1">{p.category}</div>
              <div className="mt-2 text-[14px] text-slate-600 max-w-lg">{p.description}</div>
              <Link to="/app/applications/new" className="mt-3 inline-block small-caps text-[#1F2937] hover:text-[#1F2937]">Open a file for {p.name} →</Link>
            </div>
            <div className="col-span-3 font-mono text-[13px] text-slate-700">${Math.round(p.min_amount / 1000)}K – ${(p.max_amount / 1_000_000).toFixed(0)}M</div>
            <div className="col-span-2 text-right small-caps text-slate-500">{p.time_to_close}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
